
export const environment = {
   production: false,
   showOtp: true,
   authApiUrl: "/auth-service",
   userApiUrl: "/tenant-service",
   patientApiUrl: "/patient-service",
   cmsApiUrl: "/cms-service",
   chatApiUrl: "/chat-service",
   notifApiUrl: "/notification-service",
   externalEhrApiUrl: "/external-ehr-service",
   clientId: "webapp",
   clientSecret: "saqw21!@",
   messageTimeout: 5000,
   homePath: "/main/home",
   defaultPath: "/main/care-central",
   errorPath: "/error",
   orgId: "1",
   debug: false,
   namespace: "FS",
   maxCountExpiryDays: "3",
   criticalChangeWeight: "2",
   weightChartArrowDaysDuration: "30",
   isPasswordExpiryRequired: "false" || 0,
   isShowCareTeamFilter: "true" || 0,
   isShowAddPatientWeight: "true" || 0,
   isShowPatientWeightGraph: "true" || 0,
   subKey: "",
   pubKey: "",
   cspTenantApiUrl: "https://liga.enspirit.us",
   externalIntApiUrl: "/api",
   tenantName: "LIGA",
   appoinmentStartTime: "09:00",
   appoinmentEndTime: "23:00",
   guestId: "999999",
   supportEmail: "support@myalivius.com",
   supportPhone: "+910000000000",
   masterApiUrl: "/super-admin-service",
   allNotificationChunkSize: "100" || 30,
   brand:"Lila",
   smartechRegisterKey: "undefined",
   smartechApiKey: "undefined" ,
   smartechMessageSenderId: "undefined",
   smartechAppId: "undefined",
   smartechProjectId: "undefined",
   smartechUserKey: "undefined",
   smartechSiteId: "undefined",
   smartechIdc: "undefined",
   smartechCreateKey: "undefined",
   IV:"alivioreqencrypt",
   AES_KEY:"YWxpdmlvLXRlYW0tZW5jcnlwdGlvbg=="
};
